/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/push_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdPushSettings } from "./constants";
import type { EngagementAppGroupIdPushSettingsResult } from "./types";

export const getEngagementAppGroupIdPushSettings = reactQueryFetcherAdapter(
  engagementAppGroupIdPushSettings,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementAppGroupIdPushSettingsResult> => {
    return fetch(`/engagement/${appGroupId}/push_settings`, "GET", {}, { signal });
  }
);
